import { render, staticRenderFns } from "./ExpertInformation.vue?vue&type=template&id=74da3c4b&scoped=true&"
import script from "./ExpertInformation.vue?vue&type=script&lang=js&"
export * from "./ExpertInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da3c4b",
  null
  
)

export default component.exports